import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row p-2 pb-0" }
const _hoisted_2 = { class: "col-12 offset-md-1 col-md-10 row g-0" }
const _hoisted_3 = { class: "col-md-6 col-12 pe-3" }
const _hoisted_4 = {
  key: 0,
  class: "form-group col-12"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  id: "Patient_Medicare_Number_Label",
  for: "medicare-number"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "A0600B"),
  /*#__PURE__*/_createTextVNode(" Medicare Number ")
], -1 /* HOISTED */)
const _hoisted_6 = { class: "form-group col-12 ps-0" }
const _hoisted_7 = {
  for: "mbi-number",
  id: "Mbi_Number_Label"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Medicare Beneficiary Identifier(MBI) ")
const _hoisted_9 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_10 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["value", "disabled"]
const _hoisted_14 = { class: "form-group row" }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "form-check custom-checkbox form-check-inline mt-2" }
const _hoisted_17 = {
  class: "form-check-label",
  for: "referral-medicare-beneficiary-identification-na"
}
const _hoisted_18 = { class: "me-1" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Not Applicable ")
const _hoisted_20 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "field-invalid"
}
const _hoisted_24 = { class: "form-group col-md-6 col-12" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "medicaid-number" }, " Medicaid Number ", -1 /* HOISTED */)
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "form-group row ms-1" }
const _hoisted_28 = { class: "form-check custom-radio form-check-inline mt-2" }
const _hoisted_29 = ["value", "checked"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "referral-medicaid-pending"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Pending")
], -1 /* HOISTED */)
const _hoisted_31 = { class: "form-group row ms-1" }
const _hoisted_32 = { class: "form-check custom-radio form-check-inline" }
const _hoisted_33 = ["value", "checked"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "referral-no-medicaid"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Not a Medicaid Recipient")
], -1 /* HOISTED */)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "form-group col-12" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle" }),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.cms.gov/Medicare/New-Medicare-Card/Providers/Providers-and-office-managers.html",
    target: "_blank"
  }, " Click here to review CMS guidelines on the New Medicare Beneficiary Identifier ")
], -1 /* HOISTED */)
const _hoisted_36 = { class: "col-12 col-md-10 offset-md-1 ps-0" }
const _hoisted_37 = { class: "col-12 col-md-10 offset-md-1 row g-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EligibilityCheck = _resolveComponent("EligibilityCheck")!
  const _component_PayerTable = _resolveComponent("PayerTable")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_custom_popover = _resolveDirective("custom-popover")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_FormSection, {
      title: "Payer Information",
      "full-height": false,
      "application-id": _ctx.application
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (
                                    !_ctx.patientDetails.payerInformation.medicareNumberNA &&
                                    !!_ctx.patientDetails.payerInformation.medicareNumber
                                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("p", null, _toDisplayString(_ctx.patientDetails.payerInformation.medicareNumber), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, [
                  _hoisted_8,
                  (!_ctx.patientDetails.payerInformation.medicareBeneficiaryIdentificationNA)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, "*"))
                    : _createCommentVNode("v-if", true),
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_10, _hoisted_12)), [
                    [_directive_custom_popover, { content: _ctx.sanitizeMarkup(_ctx.mbiTooltip) }]
                  ])
                ]),
                _createElementVNode("input", {
                  class: _normalizeClass(["form-control", `${
                                        _ctx.v$.patientDetails.payerInformation.medicareBeneficiaryIdentification.$error
                                            ? 'field-invalid'
                                            : ''
                                    }`]),
                  maxlength: "50",
                  name: "mbi-number",
                  type: "text",
                  placeholder: "Enter Medicare Beneficiary Identifier (MBI)",
                  value: 
                                        _ctx.formatToUppercase(
                                            _ctx.patientDetails.payerInformation.medicareBeneficiaryIdentification
                                        )
                                    ,
                  disabled: _ctx.patientDetails.payerInformation.medicareBeneficiaryIdentificationNA,
                  onChange: _cache[0] || (_cache[0] = (e) => _ctx.handleMedicareNumber(e)),
                  onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.patientDetails.payerInformation.medicareBeneficiaryIdentification.$touch && _ctx.v$.patientDetails.payerInformation.medicareBeneficiaryIdentification.$touch(...args)))
                }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_13)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "referral-medicare-beneficiary-identification-na",
                      class: "form-check-input au-target",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((
                                                _ctx.patientDetails.payerInformation.medicareBeneficiaryIdentificationNA
                                            ) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelCheckbox, 
                                                _ctx.patientDetails.payerInformation.medicareBeneficiaryIdentificationNA
                                            ]
                    ]),
                    _createElementVNode("label", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, [
                        _hoisted_19,
                        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_20, _hoisted_22)), [
                          [_directive_custom_popover, {
                                                        content: `If an MBI is entered above, selecting Not Applicable will erase it.`
                                                    }]
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              (_ctx.v$.patientDetails.payerInformation.medicareBeneficiaryIdentification.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Medicare Beneficiary Identifier is required unless N/A is checked."))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                maxlength: "50",
                placeholder: "Enter Medicaid Number",
                name: "medicaid-number",
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.patientDetails.payerInformation.medicaidNumber) = $event)),
                disabled: 
                                    _ctx.otherMedicaid == _ctx.otherMedicaidEnum?.MedicaidPending ||
                                    _ctx.otherMedicaid == _ctx.otherMedicaidEnum?.NotAMedicaid
                                
              }, null, 8 /* PROPS */, _hoisted_26), [
                [_vModelText, _ctx.patientDetails.payerInformation.medicaidNumber]
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("input", {
                    type: "radio",
                    id: "referral-medicaid-pending",
                    name: "other-medicaid",
                    class: "form-check-input au-target",
                    value: _ctx.otherMedicaidEnum.MedicaidPending,
                    checked: _ctx.otherMedicaid === _ctx.otherMedicaidEnum.MedicaidPending,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.otherMedicaidRadioClick(_ctx.otherMedicaidEnum.MedicaidPending)))
                  }, null, 8 /* PROPS */, _hoisted_29),
                  _hoisted_30
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("input", {
                    type: "radio",
                    id: "referral-no-medicaid",
                    name: "other-medicaid",
                    class: "form-check-input au-target",
                    value: _ctx.otherMedicaidEnum?.NotAMedicaid,
                    checked: _ctx.otherMedicaid === _ctx.otherMedicaidEnum?.NotAMedicaid,
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.otherMedicaidRadioClick(_ctx.otherMedicaidEnum?.NotAMedicaid)))
                  }, null, 8 /* PROPS */, _hoisted_33),
                  _hoisted_34
                ])
              ])
            ]),
            _hoisted_35
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_EligibilityCheck, {
              "first-name": _ctx.patientOptions.data.firstName,
              "last-name": _ctx.patientOptions.data.lastName,
              gender: _ctx.patientOptions.data.gender,
              "location-id": _ctx.patientOptions.data.branchId,
              "date-of-birth": _ctx.patientOptions.data.dateOfBirth,
              "medicare-number": _ctx.patientDetails.payerInformation.medicareNumber,
              "missing-url": _ctx.eligibilityMissingUrl,
              "mbi-number": _ctx.patientDetails.payerInformation.medicareBeneficiaryIdentification,
              "medicare-number-na": _ctx.patientDetails.payerInformation.medicareNumberNA,
              "mbi-number-na": _ctx.patientDetails.payerInformation.medicareBeneficiaryIdentificationNA,
              application: _ctx.application,
              "account-id": _ctx.accountId
            }, null, 8 /* PROPS */, ["first-name", "last-name", "gender", "location-id", "date-of-birth", "medicare-number", "missing-url", "mbi-number", "medicare-number-na", "mbi-number-na", "application", "account-id"])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_PayerTable, {
              "add-new-payer": _ctx.addNewPayer,
              "get-current-patient-payers": _ctx.getCurrentPatientPayers,
              "get-patient-payers": _ctx.getPatientPayers,
              "update-patient-payer": _ctx.updatePatientPayer,
              "delete-patient-payer": _ctx.deletePatientPayer
            }, null, 8 /* PROPS */, ["add-new-payer", "get-current-patient-payers", "get-patient-payers", "update-patient-payer", "delete-patient-payer"])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["application-id"])
  ]))
}